let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aIi7n")).then(() => parcelRequire('03Ycj'));